import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_TRANSACTION_INSTALLMENT_TYPE_DEF
} from "./actionTypes"

import {
    getTransactionInstallmentTypeDefListSuccess,
    apiTransactionInstallmentTypeDefApiError
} from "./actions"

import {
    getTransactionInstallmentTypeDefList
} from "../../helpers/backend_helper/backend_helper"

function* onGetTransactionInstallmentTypeDefList() {
    try {
        const response = yield call(getTransactionInstallmentTypeDefList);
        yield put(getTransactionInstallmentTypeDefListSuccess(response));
    }catch (error){
        yield put(apiTransactionInstallmentTypeDefApiError(error));
    }
}

function* transactionInstallmentTypeDefSaga() {
    yield takeEvery(GET_TRANSACTION_INSTALLMENT_TYPE_DEF, onGetTransactionInstallmentTypeDefList)
}

export default transactionInstallmentTypeDefSaga